import React, { FC } from 'react';
import cx from 'classnames';
import { routes } from 'appConstants';
import { ButtonV4 } from 'components';
import { _t, openApplicationForm } from 'utils';

import gear from 'assets/img/main-v4/services-gear.png';

import styles from './styles.module.scss';

type Props = {
  className?: string,
};

const SERVICES = [
  {
    id: 'promo',
    title: 'Продвижение',
    to: `${routes.resolutions.service.root}/buyer`,
  },
  {
    id: 'analytics',
    title: 'Аналитика',
    to: `${routes.resolutions.service.root}/analytics`,
  },
  {
    id: 'education',
    title: 'Обучение',
    to: `${routes.resolutions.service.root}/education`,
  },
  {
    id: 'export',
    title: 'Оценка экспортного потенциала',
    to: routes.auth.exportTest.root,
  },
  {
    id: 'tourism',
    title: 'Промышленный туризм',
    to: 'https://otkroimosprom.ru/projects/excursions/',
  },
  {
    id: 'hr',
    title: 'Кадры \nдля промышленности',
    to: routes.resolutions.root,
  },
];

const MainServices: FC<Props> = ({ className }) => (
  <section className={cx(styles.wrap, className)}>
    <div className={styles.panel}>
      <div className={styles.gear} aria-hidden>
        <img src={gear} alt="" />
      </div>

      <div className={styles.head}>
        <h2 className={styles.title}>{_t('Услуги')}</h2>
        <ButtonV4
          type="button"
          label="Получить бесплатную консультацию"
          variant="outline"
          tone="onDark"
          onClick={() => openApplicationForm({
            type: 'service',
            title: 'Услуги',
            path: routes.main.root,
          })}
        />
      </div>

      <ul className={styles.grid}>
        {SERVICES.map((item) => (
          <li key={item.id} className={styles.card}>
            <h3 className={styles.cardTitle}>{_t(item.title)}</h3>
            <ButtonV4
              to={item.to}
              label="Получить услугу"
              variant="outline"
              tone="onDark"
              radius="sm"
            />
          </li>
        ))}
      </ul>
    </div>
  </section>
);

export default MainServices;
